import styled from 'styled-components';
import SectionContainer from '../../components/SectionContainer';
import { HotelPanelArticle } from '../HotelPanel/styles';

export const CheckoutContainer = styled(SectionContainer)`
  flex-grow: 1;
  padding-top: 30px;
  padding-bottom: 55px;

  @media(min-width: 768px) {
    flex-wrap: nowrap;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  @media(min-width: 1024px) {
    flex-wrap: nowrap;
    padding-top: 70px;
    padding-bottom: 75px;
  }
`;

export const Column = styled.div`
  width: 100%;

  &:first-child {
    order: 1;
  }

  &:last-child {
    order: 0;
  }

  ${HotelPanelArticle} {
    padding: 0;
  }

  @media(min-width: 768px) {
    &:first-child {
      flex-grow: 1;
      order: 0;
    }

    &:last-child {
      order: 1;
      width: 320px;
      flex-shrink: 0;
      margin-left: 55px;
    }

    ${HotelPanelArticle} {
      padding: 0 30px;
      padding-top: 55px;
      padding-bottom: 15px;
    }
  }

  @media(min-width: 1024px) {
    &:last-child {
      margin-left: 150px;
    }
  }
`;

export const PageHeading = styled.div`
  margin-bottom: 30px;

  @media(min-width: 768px) {
    margin-bottom: 40px;
  }

  @media(min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 45px;
  }
`;

export const Heading = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;

  font-size: 22px;
  line-height: 1;

  @media(min-width: 768px) {
    font-size: 36px;
  }

  @media(min-width: 1024px) {
    margin-bottom: 0;
  }
`;

export const ScoreContainer = styled.article`
  display: flex;
  align-items: center;
  padding: 10px 0;

  border-top: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;

  @media(min-width: 1024px) {
    width: 100%;
    margin-top: 30px;
    padding: 20px 0;
    padding-right: 30px;
  }
`;

export const ScoreIcon = styled.div`
  margin-right: 25px;
`;

export const ScoreDescription = styled.p`
  margin: 0;
  padding: 0;

  font-size: 12px;
  line-height: 16px;

  span {
    font-weight: 700;
  }

  @media(min-width: 768px) {
    font-size: 14px;
    line-height: 18px;
  }

  @media(min-width: 1024px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
